<template>
  <!-- <v-app-bar dense app v-show="isLoggedIn"> -->
  <v-app-bar app v-show="show">
    <v-toolbar-title class="headline font-weight-light">
      <span @click="goToHomePage" style="cursor: pointer">Timertaleh</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <!--  IF the user is logged in -->
    <div>
      <v-row align="center" justify="space-between" class="ml-3">
        <v-avatar color="teal" size="48">
          <img :src="profileUrl" alt="avatar" />
        </v-avatar>
        <span class="mx-2">
          Welcome, {{ user.firstName }} {{ user.lastName}}
          <span class="teal--text">({{ user.role }})</span>
        </span>

        <div v-show="user.role != 'admin'">
          <v-menu bottom left offset-y class="mr-4">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="(item, i) in items" :key="i" @click="optionClick(item.name)">
                <v-icon color="black">{{ item.icon }}</v-icon>
                <v-list-item-title class="caption black--text ml-2">{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-row>
    </div>
    <!-- If not logged in -->
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { baseUrl } from "@/services/constants.js";

export default {
  data() {
    return {
      items: [
        { name: "Profile", icon: "mdi-account" },
        { name: "Logout", icon: "mdi-logout" }
      ]
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "loggedInUser"]),
    ...mapState("auth", ["user"]),
    profileUrl() {
      if (this.user.sex == "Male") {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/m.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/m.png");
        } else return require("@/assets/images/ST/m.png");
      } else {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/f.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/f.png");
        } else return require("@/assets/images/ST/f.png");
      }
    },
    show() {
      if (
        this.user != null &&
        Object.entries(this.user).length === 0 &&
        this.user.constructor === Object
      ) {
        return false;
      } else return true;
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    optionClick(name) {
      if (name === "Logout") {
        this.logout();
      } else if (name === "Profile") {
        this.$router.push("/my-profile");
      }
    },
    goToHomePage() {
      this.$router.push("/home");
    }
  }
};
</script>